import { h } from 'preact';
import CameraIcon from "./CameraIcon.js";
export default function SnapshotButton(_ref) {
  var onSnapshot = _ref.onSnapshot,
    i18n = _ref.i18n;
  return h("button", {
    className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--picture",
    type: "button",
    title: i18n('takePicture'),
    "aria-label": i18n('takePicture'),
    onClick: onSnapshot,
    "data-uppy-super-focusable": true
  }, CameraIcon());
}